import React from 'react';
import PropTypes from 'prop-types';
import useOnlineUsers from '../hooks/useOnlineUsers';
import { presenceList } from '../utils/onlinePresence';

const avatarImageDefault = 'https://s3.eu-west-1.amazonaws.com/public.primaverasound.com/ps-single/images/avatar.jpg';

/* imageUrl comes from the user record via the admin JWT and is usually an
 * external OAuth profile picture, which rots: the links expire, and providers
 * refuse hotlinking. Without this the avatar renders as a broken-image icon
 * with the email spilling out of its 48px box. Guarded against a loop in case
 * the fallback itself ever 404s. */
const handleAvatarError = (event) => {
  const img = event.target;
  if (img.src !== avatarImageDefault) {
    img.src = avatarImageDefault;
  }
};

const OnlineUsers = ({ slugName }) => {
  const users = useOnlineUsers(slugName);

  const usersArray = presenceList(users);

  if (usersArray.length === 0) return null;

  return (
    <div className="flex flex-wrap justify-end">
      {
        usersArray.map(({ uid, email, imageUrl }) => (
          <img
            key={uid}
            className="inline-block h-12 w-12 mr-2 rounded-full ring-2 ring-white"
            src={imageUrl || avatarImageDefault}
            title={email}
            alt={email}
            onError={handleAvatarError}
          />
        ))
      }
    </div>
  );
};


OnlineUsers.propTypes = {
  slugName: PropTypes.string.isRequired,
};


export default OnlineUsers;
